import { gql } from '@/__generated__';

const DATA_EXTRACTION_SUBSCRIPTION = gql(`#graphql
  subscription DataExtractionSubscription($userId: Int!) {
    reportCreated {
      success
      message
      urlPdf
      urlExcel
      devices {
        id
        profile {
          id
          name
          type
        }
      }
    }
  }
`);

export default DATA_EXTRACTION_SUBSCRIPTION;
